import React from "react";
import styled from "styled-components";

import { getStaticUrl } from "js/config";

const Container = styled.div<{ small?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;

    > img {
        width: 64px;
    }
`;

export function LinkByStripeIcon() {
    return (<Container>
        <img src={getStaticUrl(`/images/card_brand_icons/link_by_stripe.png`)} />
    </Container>);
}
